import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { UIProvider } from './context/UIContext';
import Home from './pages/Home';

const App = () => {
  return (
    <UIProvider>
      <Routes>
        <Route path="/*" element={<Home />} />
      </Routes>
    </UIProvider>
  );
};

export default App;
